import { Link } from 'react-router-dom';
import { ErrorBox, Kpi } from '../../components/common';
import { formatCount, formatRelative } from '../../lib/format';
import { PRODUCTION_PATH, type ProdTotals } from '../api/prodstats';
import { headline } from '../series';
import { productionIssues } from './summary';

/** The Statistics group dashboard's production block: yesterday's and the last 30 days' headline numbers. */
export function ProductionSection({
  pr,
}: {
  pr: { data: ProdTotals | null | undefined; error: unknown; loading: boolean };
}) {
  const t = pr.data;
  const y = t ? headline(t.metrics, (m) => m.yesterday) : null;
  const m = t ? headline(t.metrics, (x) => x.last30) : null;
  const issues = t ? productionIssues(t) : [];
  return (
    <div className="nyk-card" data-testid="production-section">
      <div className="nyk-card-head">
        <h2>Production</h2>
        <Link className="nyk-link" to={PRODUCTION_PATH}>
          Per day and database
        </Link>
      </div>
      <ErrorBox error={pr.error} />
      {t && !t.firstDay && <p className="nyk-ui-hint">Nothing counted yet.</p>}
      {t?.firstDay && y && m && (
        <>
          <div className="nyk-kpis">
            <Kpi
              label="Transactions yesterday"
              value={formatCount(y.transactions)}
              sub={`30 d ${formatCount(m.transactions)}`}
            />
            <Kpi
              label="Deliveries yesterday"
              value={formatCount(y.deliveries)}
              sub={`30 d ${formatCount(m.deliveries)}`}
            />
            <Kpi
              label="Delivery lines yesterday"
              value={formatCount(y.lines)}
              sub={`30 d ${formatCount(m.lines)}`}
            />
            <Kpi
              label="Shipment references yesterday"
              value={formatCount(y.shipments)}
              sub={`30 d ${formatCount(m.shipments)}`}
            />
          </div>
          <p className="nyk-ui-hint">
            Customer and purchase deliveries together. Counted{' '}
            {formatRelative(t.lastFinished?.finishedAt ?? null)}
            {issues.map((i) => ` · ${i.detail}`).join('')}
          </p>
        </>
      )}
    </div>
  );
}
